import * as type from '../ActionTypes';

const paymentInfoInitialState = {
  paymentInfo: {},
  loading: true,
  error: null,
  errorSave: false,
  saveError: null,
  saveSuccess: false,
  saving: false
};

export function createPayementInfoReducer(state = paymentInfoInitialState, action: any) {
  switch (action.type) {
    case type.GET_BANK_DETAILS:
      return {
        ...state,
        loading: true,
        error: null
      };
    case type.GET_BANK_DETAILS_SUCCESS:
      return {
        ...state,
        paymentInfo: action.data,
        loading: false,
        error: null
      };
    case type.GET_BANK_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case type.SAVE_BANK_DETAILS_REQUEST:
    case type.UPDATE_BANK_DETAILS_REQUEST:
      return {
        ...state,
        errorSave: false,
        saving: true,
        saveSuccess: false,
        saveError: null
      };
    case type.SAVE_BANK_DETAILS_SUCESSS:
      return {
        ...state,
        paymentInfo: action.data,
        errorSave: false,
        saveSuccess: true,
        saving: false,
        saveError: null
      };
    case type.SAVE_BANK_DETAILS_FAILURE:
      return {
        ...state,
        errorSave: true,
        saveError: action.error,
        saveSuccess: false,
        saving: false
      };
    case type.RESET_PAYMENT_PAGE_STATE:
      return {
        ...state,
        errorSave: false,
        saveError: null,
        saveSuccess: false,
        saving: false
      };
    default:
      return state;
  }
}
